import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const qlik = defineConnector({
  identifier: "qlik",
  name: "Qlik",
  tagLine: "Analytics and data integration platform",
  logo,
  protocol: "http",
  tags: ["data"],
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create a Qlik API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Qlik Cloud, create an API key from your profile settings and use it as a bearer token for API requests.",
        },
      ],
    },
    {
      title: "Enter your Qlik details",
      items: [
        {
          kind: "baseUrl",
          label: "Qlik tenant URL",
          required: true,
          placeholder: "https://your-tenant.us.qlikcloud.com",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "https://your-tenant.us.qlikcloud.com"}/api/v1/users/me`,
  },
  defaultUrlPattern: ({ instanceUrl }) =>
    urlToPattern(instanceUrl, "https://[^/]*\\.qlikcloud\\.com/.*"),
});
